/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/frame_ship_capital': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 32.076L2 24.037V7.965L16-.076l14 8.041v16.072l-14 8.039zM3 23.459l13 7.465 13-7.465V8.543L16 1.076 3 8.543v14.916z"/>'
  }
})
